// src/index.js
import "./App.css";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// DEBUG: log lỗi toàn cục kèm stack để biết lỗi ở file nào, dòng số mấy
// (vô hại với app; chỉ ghi ra Console để bạn khoanh vùng nhanh)
if (typeof window !== "undefined") {
  window.addEventListener("error", (e) => {
    // ví dụ: TypeError: Cannot read properties of undefined (reading 'length')
    // -> xem e.error?.stack để biết file:line
    // eslint-disable-next-line no-console
    console.log("[window.onerror]", e.message, e.error?.stack || e.error);
  });
  window.addEventListener("unhandledrejection", (e) => {
    // promise bị reject mà không catch (thường gặp khi fetch/mock)
    // eslint-disable-next-line no-console
    console.log("[unhandledrejection]", e.reason?.stack || e.reason);
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Nếu muốn đo hiệu năng, truyền console.log vào đây
// reportWebVitals(console.log);
reportWebVitals();
